import { useMutation } from '../../utils/error-handling/apollo-hooks-wrappers/custom-apollo-hooks';
import { downloadFileUtil, getFileName } from '../../utils/file-download.util';
import { InstallCertificateDocument, useGetCertificateStatusLazyQuery as _useGetCertificateStatusLazyQuery, } from '../generated/graphql-types';
export const useGetCertificateStatusLazyQuery = () => {
    const [getCertificateStatusLazy, { data, error, loading },] = _useGetCertificateStatusLazyQuery({
        variables: {},
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.getCertificateStatus,
        getCertificateStatusLazy,
    };
};
export const installCertificateMutation = () => {
    const [installCertificate, { data, error, loading }] = useMutation(InstallCertificateDocument);
    return {
        data: data?.InstallCertificate,
        error,
        loading,
        installCertificate: () => installCertificate({}),
    };
};
export const onDownloadCertificateUtil = async (fetchUrl, downloadFileName = '') => {
    await fetch(fetchUrl)
        .then(async (res) => {
        if (!res?.ok) {
            const errResponse = await res.json();
            throw new Error(`SAML certificate download failed due to ${res?.statusText}`);
        }
        const disposition = res?.headers?.get('Content-Disposition');
        const fileName = downloadFileName || getFileName(disposition);
        return {
            blob: await res?.blob(),
            fileName,
        };
    })
        .then(file => {
        return downloadFileUtil(file);
    });
};
//# sourceMappingURL=keystore-service.js.map